import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaSun, FaMoon } from 'react-icons/fa';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';

const GameLayout = ({ title, emoji, children }) => {
  const { dark, toggleTheme } = useTheme();
  const { lang, toggleLang, t } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark-900 font-inter transition-colors flex flex-col">
      {/* Compact top bar */}
      <div className="bg-gradient-to-r from-primary-900 via-primary-800 to-primary-700 dark:from-dark-950 dark:via-dark-900 dark:to-dark-900 shadow-lg">
        <div className="max-w-5xl mx-auto px-3 sm:px-6 flex items-center justify-between h-12">
          <Link
            to="/"
            className="flex items-center gap-2 text-gray-300 hover:text-white text-sm font-medium transition-colors"
          >
            <FaArrowLeft className="text-xs" />
            <span className="hidden sm:inline">{t('common.back')}</span>
          </Link>

          <div className="flex items-center gap-2">
            <span className="text-lg">{emoji}</span>
            <h1 className="text-white font-bold text-sm sm:text-base truncate max-w-[200px] sm:max-w-none">{title}</h1>
          </div>

          <div className="flex items-center gap-1.5">
            <button
              onClick={toggleLang}
              className="px-2 h-8 rounded-lg flex items-center justify-center text-xs font-bold text-gray-300 hover:text-white hover:bg-white/10 transition-all border border-white/10"
            >
              {lang === 'id' ? 'EN' : 'ID'}
            </button>
            <button
              onClick={toggleTheme}
              className="relative w-8 h-8 rounded-lg flex items-center justify-center text-gray-300 hover:text-white hover:bg-white/10 transition-all"
            >
              <span className={`absolute transition-all duration-300 ${dark ? 'opacity-0 rotate-90 scale-0' : 'opacity-100 rotate-0 scale-100'}`}>
                <FaMoon className="text-sm" />
              </span>
              <span className={`absolute transition-all duration-300 ${dark ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 -rotate-90 scale-0'}`}>
                <FaSun className="text-sm text-gold-400" />
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Game content — fills remaining space */}
      <div className="flex-1 flex flex-col">
        <div className="flex-1 w-full max-w-3xl mx-auto px-3 sm:px-6 py-4 sm:py-6">
          {children}
        </div>
      </div>
    </div>
  );
};

export default GameLayout;
